import { Injectable } 			from '@angular/core';
import { Observable } 			from 'rxjs/Rx'

@Injectable()
export class StorageService {
  constructor(){}

  storeAll(user) {
    var use = encodeURI(JSON.stringify(user.data.user));
    localStorage.setItem('user', use);

    var pending = encodeURI(JSON.stringify(user.data.pending_surveys));
    localStorage.setItem('pending_surveys', pending);
    var firstLogin = encodeURI(JSON.stringify(user.data.first_login));
    localStorage.setItem('first_login', firstLogin);
  }

  storeObject(type, data) {
    localStorage.setItem(type, JSON.stringify(data));
  }

  storeItem(type, data) {
    localStorage.setItem(type, data);
  }

  getObject(name) {
    var object = decodeURI(localStorage.getItem(name));
    return JSON.parse(object);
  }

  getItem(name) {
    var item = decodeURI(localStorage.getItem(name));
    return localStorage.getItem(item);
  }

  removeAll() {
    localStorage.removeItem('user');
    localStorage.removeItem('first_login');
    localStorage.removeItem('pending_surveys');
    localStorage.removeItem('settings');
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/storage.service.ts